// Job listings data file
// This file can be edited to add, modify, or remove job listings without changing application code

const jobListings = [
  
  /*{
    id: "founding-sales-lead",
    title: "Founding Sales Lead",
    location: "Remote (DE)",
    type: "Full-Time",
    department: "Sales",
    description: "You’ll be the go-to business champion, driving ARAMA’s adoption among SMEs.",
    formUrl: "https://tally.so/r/3qNQ59"
  },
  */
];

export default jobListings;